import React from 'react';

const AdminAccessPolicy: React.FC = () => (
 <div className="max-w-3xl mx-auto p-6 md:p-8 bg-white">
  <h1 className="text-2xl font-bold mb-2">관리자 view-as 정책</h1>
  <p className="text-sm text-gray-500 mb-6">최종 업데이트: 2026-05-08</p>

  <section className="space-y-4 text-sm leading-6 text-gray-800">
   <p>
    MOcombinator 운영팀은 회원 지원·디버깅·정책 위반 조사를 위해 제한된 범위 안에서
    회원 계정으로 <strong>read-only view-as</strong> 진입할 수 있습니다. 본 정책은
    그 절차·범위·이용자 권리를 명시합니다.
   </p>

   <h2 className="text-lg font-semibold text-gray-900 mt-6">1. 허용 범위</h2>
   <ul className="list-disc list-inside space-y-1">
    <li><strong>읽기 전용</strong> — 모패밀리·캠페인·슬롯·파일 등 view-as 대상의 화면을 그대로 조회만 가능합니다.</li>
    <li><strong>비-GET 요청 차단</strong> — 생성/수정/삭제·결제·송금 등 모든 write 액션은 시스템 차원에서 거부됩니다 (HTTP 403, 코드 <code>SUDO_READONLY</code>).</li>
   </ul>

   <h2 className="text-lg font-semibold text-gray-900 mt-6">2. 금지 범위</h2>
   <ul className="list-disc list-inside space-y-1">
    <li><strong>메시지함·채팅 열람 불가</strong> — <code>/messages</code>, <code>/chat</code> 등의 경로는 view-as 중 모두 차단됩니다 (HTTP 403, 코드 <code>SUDO_NO_MESSAGES</code>). 통신비밀보호법 보호 대상에 해당하기 때문입니다.</li>
    <li>관리자가 view-as 상태에서 회원 계정으로 메시지를 보내거나 거래를 체결하는 행위는 시스템적으로 불가능합니다.</li>
   </ul>

   <h2 className="text-lg font-semibold text-gray-900 mt-6">3. 투명성 보장</h2>
   <ul className="list-disc list-inside space-y-1">
    <li><strong>대상 사용자에게 즉시 알림</strong> — 진입 시점에 시스템 메시지가 inbox 로 전달됩니다.</li>
    <li><strong>로그인 시 모달 알림</strong> — 사용자가 로그인할 때 활성 view-as 가 있으면 즉시 모달로 통지합니다.</li>
    <li><strong>가시 배너</strong> — 관리자 측 화면 최상단에 빨간 배너로 view-as 모드임을 항상 표시합니다.</li>
    <li><strong>이력 공개</strong> — 본인의 프로필 페이지에서 최근 30일 진입/종료 이력을 직접 조회할 수 있습니다.</li>
    <li><strong>audit log 영구 보존</strong> — <code>activity_logs</code> 테이블에 sudo_start / sudo_end 가 영구 기록됩니다.</li>
   </ul>

   <h2 className="text-lg font-semibold text-gray-900 mt-6">4. 신고 / 이의 제기</h2>
   <p>
    부적절한 view-as 진입을 발견하셨거나 이의를 제기하시려면{' '}
    <a href="/api/contact" className="text-blue-600 hover:underline">고객 지원</a> 으로
    문의해 주세요. 진입한 관리자의 hash·시각이 audit log 에 보존되어 있으므로 모든 진입을 추적·검증할 수 있습니다.
   </p>

   <h2 className="text-lg font-semibold text-gray-900 mt-6">5. 향후 확장 시 별도 동의</h2>
   <p>
    write 액션 (Full sudo) 또는 메시지 열람이 필요한 시나리오 (예: 법원 영장)가 발생할 경우,
    별도 약관 개정과 명시적 동의 절차 없이는 시스템 차원에서 활성화되지 않습니다.
   </p>
  </section>

  <div className="mt-8 pt-4 border-t border-gray-200 text-xs text-gray-500">
   문의: ejacoo@gmail.com · MOcombinator 운영팀
  </div>
 </div>
);

export default AdminAccessPolicy;
